import { render, staticRenderFns } from "./MultiselectGroup.vue?vue&type=template&id=b13d7666&scoped=true"
import script from "./MultiselectGroup.vue?vue&type=script&lang=js"
export * from "./MultiselectGroup.vue?vue&type=script&lang=js"
import style0 from "./MultiselectGroup.vue?vue&type=style&index=0&id=b13d7666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13d7666",
  null
  
)

export default component.exports